<!-- Backdrop -->
<div
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70] p-4 backdrop-blur-sm animate-[fadeIn_0.2s_ease]"
  (click)="cancel()">
  <!-- Dialog -->
  <div class="bg-white dark:bg-slate-800 rounded-lg shadow-2xl w-full max-w-md overflow-hidden animate-[scaleIn_0.3s_ease]"
    (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="p-5 pb-3">
      <div class="flex items-start gap-3">
        <!-- Icon -->
        <div class="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center" [ngClass]="{
            'bg-error-light': type() === 'danger',
            'bg-warning-light': type() === 'warning',
            'bg-info-light': type() === 'info',
            'bg-primary-800/10': type() === 'primary'
          }">
          @if (type() === 'danger') {
          <svg class="w-5 h-5 text-error" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z">
            </path>
          </svg>
          }
          @if (type() === 'warning') {
          <svg class="w-6 h-6 text-warning" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z">
            </path>
          </svg>
          }
          @if (type() === 'info') {
          <svg class="w-6 h-6 text-info" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          }
          @if (type() === 'primary') {
          <svg class="w-5 h-5 text-primary-800 dark:text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          }
        </div>

        <!-- Content -->
        <div class="flex-1">
          <h3 class="text-base font-medium text-gray-900 dark:text-white mb-2">
            {{ title() }}
          </h3>
          <div class="text-xs text-gray-500 dark:text-slate-400 space-y-2">
            <p>{{ message() }}</p>
            @if (itemName()) {
            <p class="font-normal text-xs text-gray-700 dark:text-slate-300 bg-gray-50 dark:bg-slate-800 px-3 py-2 rounded-md border border-gray-200 dark:border-slate-700">
              "{{ itemName() }}"
            </p>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="bg-gray-50 dark:bg-slate-800 px-5 py-3 flex items-center justify-end gap-2">
      <!-- Cancel Button -->
      <button type="button" (click)="cancel()"
        class="px-3 py-2 text-xs font-normal text-gray-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-800 hover:border-gray-400 transition-all duration-200 shadow-sm">
        {{ cancelText() }}
      </button>

      <!-- Confirm Button -->
      <button type="button" (click)="confirm()"
        class="px-3 py-2 text-xs font-normal text-white rounded-lg transition-all duration-200 shadow-sm" [ngClass]="{
          'bg-error hover:bg-error-dark': type() === 'danger',
          'bg-warning hover:bg-warning-dark': type() === 'warning',
          'bg-info hover:bg-info-dark': type() === 'info',
          'bg-primary-800 hover:bg-primary-900': type() === 'primary'
        }">
        {{ confirmText() }}
      </button>
    </div>
  </div>
</div>